import React, { Component } from 'react';
import {Head, Link, withRouteData} from 'react-static';
import styled from "styled-components";

import Header from '../components/Header';
import Footer from '../components/Footer';
import SocialLinks from "../components/SocialLinks";

const TermsStyle = styled.div`
	h4 {
		margin-top: 1.5rem;
	}
	
	p > p {
		margin-bottom: 0;
	}
	
	.container {
		margin-bottom: 2rem;
	}
`;

class Terms extends Component {
	render() {
		return (
			<TermsStyle>
				<Head>
					<title>Terms of Service | CTR Group</title>
					<meta name="description" content="Please follow the link to read our terms of service. If you have any questions, please contact our support team." />
				</Head>
				<Header />
				<div>
					<div className="container">
						<div className="row">
							<div className="columns medium-12">
								<h1 className="green text-center small-centered">Terms of Service</h1>
								<p className="caption">
									Sonera Corporative Ltd is a commercial organization that pursues various business goals,
									including consulting services, mergers, acquisitions and investments of various types of joint
									commercial programs through enterprises all over the world, acting on the basis of the
									Company's Charter and as a payer of income tax on general grounds in according to the
									United Kingdom Tax Code, hereinafter referred to as the "Contractor" on the one hand, and
									A user acting in accordance with the civil and tax laws of his country, as well as international
									regulatory documents, hereinafter referred to as the "Customer", on the other hand,
									both together hereinafter referred to as the "Parties", by electronic means of communication,
									have signed this service agreement, hereinafter referred to as the "User Agreement" on the
									following grounds:
								</p>

								<h4 className="green">1. DEFINITIONS AND INTERPRETATION</h4>
								<p className="caption">
									In this User Agreement, unless otherwise provided by the context, the following expressions
									will have the following meanings:
									<br/>"Website" - website https://ctr.group;
									<br/>"Product" is a radio transmitter system with capacity transfer (CTR - Capacity Transfer
									Radio);
									<br/>"Alpha version" - A product that is functionally ready to a large extent, allowing you to test
									the performance, test on the network and evaluate for further production and integration;
									<br/>"Beta version" - A product that is functionally full and usable in all meaningful senses, but
									not yet serial (not assembled and tested by the contract manufacturer);
									<br/>"Preparatory and organizational stage of the program for the production and
									implementation of the Product", hereinafter in the User Agreement referred to as "Stage
									1", which provides for the establishment of enterprises to create the Product and the necessary
									resources to promote this Product worldwide;
									<br/>"Production stage of the program", hereinafter referred to as the "Stage 2";, providing for
									the creation of "Alpha versions" and "Beta versions" of the Product;
									<br/>"Implementation stage of the program", hereinafter referred in the User Agreement
									referred to as "Stage 3", which provides for the serial production and implementation of the
									Product;
									<br/>"Token" - CTRcoin with a nominal value of 0.50 euros;
									<br/>"Services"; means the services rendered by the Contractor to the Customer, namely:
									services for the use of a software product hosted on the Website, which includes:
									<br/>- Creation of personal cabinet;
									<br/>- Provision of the financial participation of the Customer in Stage 1 and Stage 2 of the project
									for the production of the Product through the acquisition of Tokens;
									<br/>- Acquisition of the Product for the purpose of subsequent sale to third parties;
									Payment services using electronic payment systems, including peer-to-peer systems.
								</p>

								<h4 className="green">2. PREAMBLE</h4>
								<p className="caption">
									2.1. This User Agreement is a public offer. In order to use the Services provided on this
									Website, the Customer must agree to comply with the terms and conditions contained in this
									document. Using the Website, the Customer accepts these terms and agrees to comply with
									them. If the Customer does not agree to these terms, he must refrain from any use of the
									Website and the Services. The Customer agrees that the Contractor, Sonera Corporative Ltd,
									regards the use of the Website as its complete acceptance of the terms and conditions
									contained in this document at the moment.
									<br/>2.2. By opening an account on the Website, the Customer assumes responsibility for
									compliance with all conditions contained in this User Agreement. All new functions and tools
									that can be added to the Services must comply with this User Agreement. The customer can
									read the current version of the User Agreement at any time on this page. The Contractor
									reserves the right to amend and change the Services by amending this User Agreement. The
									Contractor recommends that the Customer periodically check this User Agreement in order to
									be aware of all new possible conditions that may or may not concern the Customer. These
									conditions are of great importance, since they are mutually binding.
									<br/>2.3. Service management of the Contractor is carried out through a convenient User platform
									that provides the Customer with full control over his / her account, including control over
									financing transactions, purchase and sale of final products. After registration, the Customer is
									solely responsible for using his / her account. Under no circumstances will the Contractor be
									liable to any natural or legal person for any loss or damage caused as a result of actions on this
									platform. Orders that have been confirmed by the Customer can not be canceled, deleted or
									reimbursed under any circumstances. The customer should carefully read the CTR Return
									Policy, the CTR usage guide and the information posted in the FAQ. <Link to={`${this.props.language === "" ? "" : "/"}${this.props.language}/privacy-policy`}>Privacy Policy</Link>
									, <Link to={`${this.props.language === "" ? "" : "/"}${this.props.language}/refund-policy`}>Refund Policy</Link>
									, <Link to={`${this.props.language === "" ? "" : "/"}${this.props.language}/payment-policy`}>Payment Policy</Link> and delivery are part of this User Agreement and terms of use. If the
									Customer has questions or doubts, he should contact the Contractor’s Support Service by e-mail to learn more information.
								</p>

								<h4 className="green">3. SUBJECT AGREEMENT</h4>
								<p className="caption">
									3.1. Under the terms of this User Agreement, the Contractor provides the Customer with the
									Services for the use of the Software Product.
									<br/>3.2. Payment for the Product purchased from third parties using the Website is performed
									exclusively between the Contractor and third parties. In cases where the Contractor acts as an
									agent, supplier, buyer or agent of the supplier and / or buyer, such relations are governed by a
									separate agreement.
									<br/>3.3. The contractor provides its own logistics infrastructure for the design, production and sale
									of the CTR project products to its counterparties.
									<br/>3.4. The proposed profit is calculated on the basis of the price spent for production and the
									price achieved by selling the final product. Proposed profits are posted on the Website.
									<br/>3.5 The fluctuations in the price of the Product, as well as the cost of delivery, can be
									transferred to the Customers.
									<br/>3.6. The Contractor has the right to limit the volume of the Services provided, to suspend the
									sale of the Product in the event if the design and production process can not be carried out due
									to unforeseen interruptions in production, and also to disable the option to purchase the
									Product if the purchase limit or other technical reasons is reached.
									<br/>3.7. Risk distribution: in case the break is caused by force majeure circumstances, the
									Contractor has the right to cancel the Sale of the product and distribute the risk with its
									partners / users.
									<br/>3.8. Subject to the financial participation of the Customer in the Stage 1 and the Stage 2 of the
									program for the production and implementation of the Product, by acquiring Tokens in the
									amount not less than 10 000 (Ten thousand Euros), the Customer shall be entitled to
									participate in the Stage 3 of the program for the production and implementation of the Product
									on following conditions:
									<br/>- to purchase the Product at a discount of 15% of the declared sale price on the site;
									<br/>- to purchase any other product, service or individual offer from the Contractor declared on the
									Website with a discount of 15% of the offered price in exchange for Tokens.
								</p>

								<h4 className="green">4. OBLIGATIONS AND RIGHTS OF THE CONTRACTOR</h4>
								<p className="caption">
									4.1. Under the terms of this User Agreement, the Contractor shall:
									<br/>- Register the Customer's data on the Website and provide the Customer with
									recommendations on using the personal cabinet and placing orders;
									<br/>- Advise the Customer on the use of the Software Product on an ongoing basis.
									<br/>4.2. The Contractor has the right:
									<br/>- Refuse to provide the Customer with the Services provided for in clause 3.1 of this User
									Agreement in the event of failure to perform or improper fulfillment by the Customer of the
									terms of this Agreement;
									<br/>- Make changes to this User Agreement at its sole discretion and provide the Customer with
									the opportunity to review such changes on the Website;
									<br/>- Monitor the fulfillment by the Customer of the obligations set forth in this User Agreement.
								</p>

								<h4 className="green">5. OBLIGATIONS AND RIGHTS OF THE CUSTOMER</h4>
								<p className="caption">
									5.1. The Customer is obliged:
									<br/>- Comply with the terms of this User Agreement;
									<br/>- Timely pay for the Services provided by the Contractor on terms and in the amount
									established in Section 6 of this User Agreement;
									<br/>5.2. The customer has the right:
									<br/>- To monitor the performance by the Contractor of the obligations set forth in this User
									Agreement;
									<br/>- Receive information support from the Contractor upon requests sent to the latter by e-mail.
								</p>

								<h4 className="green">6. FINANCIAL RELATIONS</h4>
								<p className="caption">
									6.1. The expected profit mentioned in clause 3.4 of this User Agreement is calculated once a
									year at the end of the reporting period (annual balance sheet).
									<br/>6.2. Payment for services provided for in this User Agreement is carried out simultaneously
									with the payment of the value of the Products sold by the Customer in non-cash form by
									withholding the appropriate amount from the amount due to the Customer. If such deduction
									is not possible, payment for services is effected within five working days from the date of
									receipt by the Customer of a payment request from the Contractor.
									<br/>6.3. In the event that the Contractor provides additional services, the final calculations are
									made by the Customer in accordance with the terms of the supplementary agreement.
									<br/>6.4. The Contractor reserves the right to make changes in the pricing policy by publishing the
									changed price information on the Website and / or by notifying the Customer by e-mail.
									<br/>6.5. Each party is responsible for compliance with anti-money laundering legislation. At the
									request of the Contractor, the Customer is obliged to provide any required information or
									documentation, before / during or after any financial transaction.
									<br/>6.6. Under the terms of this User Agreement, the Contractor is not responsible for the
									Customer's interaction with suppliers and buyers through the Web site, does not exercise
									control over the execution of any transactions and agreements, the targeted use of funds and
									does not resolve any disputes and disagreements. The Contractor uses the services of third
									parties, such as banks, electronic payment systems, financial institutions and others, for the
									purpose of raising funds, and thus is not responsible for the provision of these services by
									third parties, but he must make every effort to ensure that these services to the Customer
									rendered. The Contractor can not influence the pricing policy of payment systems, therefore
									the Customer independently makes a choice in favor of the services of one of the available
									payment systems and receives the necessary information from information sources of the
									respective payment systems and banks.
								</p>

								<h4 className="green">7. RESPONSIBILITY OF THE PARTIES</h4>
								<p className="caption">
									7.1. Parties are liable in cases and in accordance with the procedure provided for by the
									applicable laws of the United Kingdom.
									<br/>7.2. The Parties are liable in accordance with the applicable laws of the United Kingdom in
									the event of non-performance or improper performance of the terms of this User Agreement.
									A breach of an obligation is a failure to perform or improper performance, which is an
									execution in violation of the conditions set forth in this User Agreement.
									<br/>7.3. A Party is presumed innocent if he or she can prove that all the necessary actions have
									been taken to fulfill the obligations.
									<br/>7.4. The payment of the fee or commission under this User Agreement provided for by the
									laws of the United Kingdom does not exempt the Parties from fulfilling the obligations
									entrusted to them by this User Agreement.
									<br/>7.5. In the event of an overdue payment under this User Agreement on the part of the
									Customer, the Customer is obliged to pay a daily penalty for the delayed payment of 0.1% of
									the total amount of the overdue payment.
									<br/>7.6. Neither Party shall be liable for non-fulfillment of obligations under this User Agreement,
									if the cause of such failure is force majeure, such as an emergency, force majeure
									circumstances, as well as other circumstances objectively independent of the will of the
									Parties. Such circumstances must be confirmed by a competent state body.
									<br/>7.7. In the event of failure to provide the Services requested by the Customer due to technical
									failure for a long time, the Contractor reserves the right to terminate this User Agreement
									without applying penalties to it.
								</p>

								<h4 className="green">8. SETTLEMENT OF DISPUTES</h4>
								<p className="caption">
									8.1. Disputes that may arise during the execution of this User Agreement must be resolved by
									the Parties through negotiations.
									<br/>8.2. All claims in connection with this User Agreement are considered by the Parties in
									accordance with the requirements of the English law of the United Kingdom.
									<br/>8.3. Disputes that have not been settled by the Parties shall be settled by a court of competent
									jurisdiction in accordance with the substantive and procedural legislation of the United
									Kingdom.
									<br/>8.4. The Contractor is not a judicial body or arbitration commission and does not participate in
									the settlement of any disputes between Customers, reserving the right to collect the necessary
									information about the disputes that have arisen.
									<br/>8.5. Both parties are responsible for the non-disclosure of any information or statements
									regarding any disagreements, past or current.
								</p>

								<h4 className="green">9. TERM AND TERMINATION OF THE AGREEMENT</h4>
								<p className="caption">
									9.1. This User Agreement comes into effect after the Customer's registration on the Website,
									which enters into this public User Agreement in the form of a written electronic document,
									and is valid for the entire period of using the Services by the Customer. Upon completion of
									the registration process, the Customer becomes one of the Parties to this User Agreement and
									is responsible for compliance with the requirements contained therein. If the Customer
									registers on the Website on behalf of another private or legal entity, the Customer represents
									and warrants that he or she has all the powers and rights to assume the responsibility provided
									for in this User Agreement on behalf of these third parties.
									<br/>9.2. The Customer does not have the right to transfer his rights or obligations under this User
									Agreement to any third party without the prior written consent of the Contractor.
									<br/>9.3. For the purposes of implementing this User Agreement, the Parties are obliged to
									exchange information related to their mutual interests and, if necessary, advise each other.
									<br/>9.4. The Contractor or the Customer has the right to terminate this User Agreement at any
									time for any reason, having informed the other Party about it. The Contractor has the right at
									any time to terminate the provision of the Service to the Customer both with an indication of
									the reasons for such termination, and without it, provided that:
									<br/>- The Customer does not use his account for 12 months. In this case, its account is deactivated
									and can be permanently deleted along with all the data associated with the account;
									<br/>- Actions performed by the Customer using the CTR account may damage the Contractor's
									business reputation;
									<br/>- Further provision of the Services may cause substantial damage to the legitimate interests of
									third parties;
									The Customer requested the account closure. In this case, the Refund Policy is in effect.
									<br/>9.5. If the Customer decides to close the account, the process of production and sale of the
									CTR product must be completed and the Customer will be given the right to withdraw the
									profit share from the sale. The account will be permanently closed after the payment is made.
								</p>

								<h4 className="green">10. OTHER PROVISIONS</h4>
								<p className="caption">
									10.1. The Parties confirm that they understand the meaning and wording of this User
									Agreement and that they sign it voluntarily, based on the principles of mutual understanding.
									<br/>10.2. By signing this User Agreement, the Customer gives his consent to the processing of his
									or her personal information in accordance with the requirements of the English law of the
									United Kingdom.
									<br/>10.3. Disputes that may arise during the execution of this User Agreement and are not
									governed by this User Agreement shall be settled in accordance with the applicable English
									law of the United Kingdom.
									<br/>10.4. The Customer respects the Contractor's rights to the Website and the software used to
									provide the Customer with the Services (patents, trademarks and service marks, graphics and
									copyrights). If the Customer wishes to use the Contractor's rights, the Customer must obtain
									the consent of the Contractor and agree with the Contractor all terms and conditions by
									contacting the Contractor using the information posted on the website's contact information
									page. The use, reproduction, modification, distribution or storage of any part of the Services,
									including any information contained therein, for any purpose other than personal or non-
									commercial use, is prohibited without the Customer receiving the Contractor's prior written
									consent. The Customer does not have the right to copy, modify, create derivative materials,
									decode technology codes, decompile and obtain the source code of any part of the Services in
									any possible way without obtaining the prior written consent of the Contractor, and has no
									right to allow third parties to perform such actions. Not providing such prior written consent
									on the part of the Contractor means that the Customer can not transfer the rights to use the
									Services, as well as transfer them under sublicense conditions, grant the right to use the
									Services or otherwise transfer any rights to use the Services and the duties related to the
									Services.
									<br/>10.5. If the Customer becomes aware of a possible violation of this User Agreement by any
									person, the Customer is obliged to report the fact of such violation to the Contractor.
									<br/>10.6. The customer has the right to refer to any page of the Website provided that such action
									is lawful and there is no harm to the Contractor's reputation. For questions regarding the use of
									any materials on the Website, contact the Contractor at Sonera Corporative Ltd using the
									contact information on the Contact Website page.
									<br/>10.7. Each of the provisions of this User Agreement is valid, and in the event of any dispute
									regarding any of the provisions of this User Agreement, all other provisions remain effective.
									<br/>10.8. It is prohibited to reproduce, distribute or transmit in any form or by any means,
									including by photocopying, recording or otherwise creating electronic or physical copies, any
									parts of the website https://ctr.group or publications on social networks made Sonera
									Corporative Ltd., without the written consent of Sonera Corporative Ltd. This restriction also
									applies to the use of the term CTR in a domain name or application for mobile devices.
									<br/>10.9 Disclosure and / or distribution of false statements against the Contractor - Sonera
									Corporative Ltd or a Sonera Corporative Ltd. employee, who (a) may damage the reputation
									of the company or such person; or (b) may cause harm to their professional or commercial
									activities, entails appropriate litigation regarding the source / distributor of defamatory
									information. In addition, this also entails the immediate and final blocking of the account of
									the source of such information, if the source has an account in the CTR.
									<br/>10.10. The spread of defamatory information can be considered (a) words spoken aloud, or
									audible sound; or (b) words intended for reading by sight or tactile perception; or (c) signs,
									signals, gestures or other visible representations.
								</p>

								<h4 className="green">OTHER REFERENCES</h4>
								<p className="caption">Also see our <Link to="/privacy-policy">Privacy Policy</Link>, our <Link to="/payment-policy">Payment Policy</Link> and our <Link to="/refund-policy">Refund Policy</Link>.</p>
								<p className="caption">Flag icons made by <a href="https://www.freepik.com" title="Freepik">Freepik</a> from <a href="https://www.flaticon.com/" title="Flaticon">www.flaticon.com</a></p>
								<p className="caption">"Cryptocurrency" icon made by <a href="https://www.flaticon.com/authors/itim2101" title="itim2101">itim2101</a> from <a href="https://www.flaticon.com/" title="Flaticon">www.flaticon.com</a></p>
								<p className="caption">"Bank" icon made by <a href="https://www.flaticon.com/authors/eucalyp" title="Eucalyp">Eucalyp</a> from <a href="https://www.flaticon.com/" title="Flaticon">www.flaticon.com</a></p>

								<h4 className="green">CONTACT</h4>
								<p className="caption">For general inquiries, you can contact us by E-Mail at <a href="mailto:info@ctr.group">info@ctr.group</a></p>
								<p className="caption">If you have a technical or site related issue, contact us at <a href="mailto:support@ctr.group">support@ctr.group</a></p>
								<p className="caption">You can also join our <a href="https://t.me/ctrgroupico" target="_blank" rel="noopener noreferrer">Telegram Channel</a></p>
							</div>
						</div>
					</div>
				</div>
				<SocialLinks />
				<Footer />
			</TermsStyle>
		)
	}
}

export default withRouteData(Terms)


// WEBPACK FOOTER //
// /opt/build/repo/src/containers/Terms.js